import { render } from "./DettagliCliente.vue?vue&type=template&id=45acfbe0&scoped=true"
import script from "./DettagliCliente.vue?vue&type=script&lang=js"
export * from "./DettagliCliente.vue?vue&type=script&lang=js"

import "./DettagliCliente.vue?vue&type=style&index=0&id=45acfbe0&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45acfbe0"]])

export default __exports__